import React, { useState, useEffect, useContext, useCallback, useRef, useMemo } from 'react';
import { fetchStudentData, deleteStudent } from "../../services"
import { MyContext } from '../..';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import { pink } from '@mui/material/colors';
import Alert from "react-popup-alert";

import { AgGridReact } from 'ag-grid-react';

export default function StudentsList(props) {
    document.title = props.title
    const { backendUrl } = useContext(MyContext)
    const queryParameters = new URLSearchParams(window.location.search);
    const subscriberCode = queryParameters.get("subcode")?.toUpperCase() || props.subCode;
    const [studentData, setStudentsData] = useState([])
    const [alert, setAlert] = React.useState({
        type: "error",
        text: "This is a alert message",
        show: false,
    });
    const gridRef = useRef();
    const handleDeleteStudent = async (username) => {
        try {
            const response = await deleteStudent(backendUrl, username)
            if (response.code === 200) {
                setAlert({
                    type: "error",
                    text: response.message,
                    show: true,
                });

            }
            else {
                setAlert({
                    type: "danger",
                    text: response.message,
                    show: true,
                });
            }
        } catch (error) {
            setAlert({
                type: "danger",
                text: error,
                show: true,
            });
        }
    }
    useEffect(() => {
        async function fetchData() {
            try {
                const data = await fetchStudentData(backendUrl, subscriberCode);
                setStudentsData(data.students);
            } catch (error) {
                console.error('Error fetching student data:', error);
            }
        }

        fetchData();

    }, [backendUrl, subscriberCode]);

    const columns = [
        { field: 'id', headerName: 'Id', width: 70, pinned: 'left' },
        { field: 'full_name', headerName: 'Name', width: 200, pinned: 'left' },
        { field: 'status', headerName: 'Status', width: 100 },
        { field: 'grade', headerName: 'Grade', width: 100 },
        { field: 'email', headerName: 'Email', width: 200 },
        { field: 'username', headerName: 'Username', width: 200 },
        { field: 'phone_number', headerName: 'Phone Number', width: 150 },
        { field: 'parent_name_1', headerName: 'Parent Name 1', width: 150 },
        { field: 'parent_name_2', headerName: 'Parent Name 2', width: 150 },
        { field: 'ip_address', headerName: 'IP', width: 130 },
        { field: 'country_code', headerName: 'Country', width: 100 },
        { field: 'notes', headerName: 'Notes', width: 200 },
        { field: 'formated_created_on', headerName: 'Created On', pinned: 'right', width: 150 },
        {
            field: 'username',
            headerName: 'Actions',
            width: 100,
            pinned: 'right',
            cellRenderer: ({ value }) => (
                <>
                    <Link to={`/student/settings?username=${value}&subcode=${subscriberCode}&orgcode=${"vss"}&role=a`}>
                        <EditIcon color="primary" />
                    </Link>
                    <DeleteIcon color="primary" sx={{ color: pink[500] }} onClick={() => handleDeleteStudent(value)} style={{ cursor: "pointer" }} />
                </>
            ),
        },
    ];
    function onCloseAlert() {
        setAlert({
            type: "",
            text: "",
            show: false,
        });
        window.location.reload()
    }
    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            'quickFilterText',
            document.getElementById('filter-text-box').value
        );
    }, []);
    const defaultColDef = useMemo(() => {
        return {
            filter: true,
        };
    }, []);
    return (
        <div>
            <Alert
                header={"Message"}
                btnText={"Close"}
                text={alert.text}
                type={alert.type}
                show={alert.show}
                onClosePress={onCloseAlert}
                pressCloseOnOutsideClick={true}
                showBorderBottom={true}
                alertStyles={{}}
                headerStyles={{}}
                textStyles={{}}
                buttonStyles={{}}
            />
            <div className='example-wrapper'>
                <div className="example-header">
                    <span>Quick Filter:</span>
                    <input
                        type="text"
                        id="filter-text-box"
                        placeholder="Filter..."
                        onInput={onFilterTextBoxChanged}
                    />
                </div>
                <div style={{ height: "90vh", width: '100%' }} className='ag-theme-quartz'>
                    <AgGridReact ref={gridRef} rowData={studentData} columnDefs={columns} defaultColDef={defaultColDef} pagination={true} />
                </div>
            </div>

        </div>
    )
}
